import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { ErrorBoundary as m } from "react-error-boundary";
import { IconNames as c } from "@blueprintjs/icons";
import { Button as e } from "@strata/react-buttons";
import { MessagingBlock as o } from "@strata/react-messaging-block";
import "./main.scss";
const d = () => /* @__PURE__ */ i("div", { className: "sds_error-page", children: [
  /* @__PURE__ */ r(
    o,
    {
      className: "sds_error-page__message",
      size: o.Sizes.LARGE,
      icon: c.ERASER,
      iconStatus: o.Status.ERROR,
      primaryText: "Uh oh, something went wrong.",
      secondaryText: "We are very sorry for the inconvenience, we have logged the issue and are working to erase it."
    }
  ),
  /* @__PURE__ */ r("a", { href: "/home", children: /* @__PURE__ */ r(e, { intent: e.Intent.PRIMARY, large: !0, label: "Go Home" }) })
] }), y = ({ onError: n, children: a }) => /* @__PURE__ */ r(
  m,
  {
    FallbackComponent: d,
    onError: (s, t) => n("Unhandled Error", { error: s, info: t }),
    children: a
  }
);
export {
  y as ErrorBoundary
};
//# sourceMappingURL=index.js.map
